import { ResourceManager } from "@/components/ResourceManager";
import { Newspaper } from "lucide-react";

const fields = [
  { name: "title", label: "Title", type: "text", required: true },
  { name: "category", label: "Category", type: "select", options: ["News", "Announcement", "Notice", "Press Release", "Yatra Update", "Program Update"] },
  { name: "date", label: "Date", type: "date" },
  { name: "excerpt", label: "Excerpt", type: "textarea", table: false },
  { name: "content", label: "Content", type: "textarea", rows: 6, table: false },
  { name: "image_path", label: "Image", type: "image", table: false },
];

export default function NewsAdmin() {
  return <ResourceManager title="News & Announcements" eyebrow="Content" endpoint="news" fields={fields} hasPublish icon={Newspaper} />;
}
